import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MenuComponent } from './dashboard/menu/menu.component';
import { HomeFooterComponent } from './home/home-footer/home-footer.component';
import { HomeHeaderComponent } from './home/home-header/home-header.component';
import { HomeComponent } from './home/home.component';
import { LogoutComponent } from './logout/logout.component';
import { PhysicianModalComponent } from './physician-modal/physician-modal.component';

@NgModule({
  declarations: [
    DashboardComponent,
    MenuComponent,
    PhysicianModalComponent,
    LogoutComponent,
    HomeComponent,
    HomeHeaderComponent,
    HomeFooterComponent,
  ],
  imports: [SharedModule, RouterModule],
  exports: [DashboardComponent, HomeComponent],
})
export class LayoutModule {}
